import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { states } from "../../../reducers/queriesStates";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import ReportConstructorTitleEdit from "./ReportConstructorTitleEdit";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ReportConstructorToolPanel from "./ReportConstructorToolPanel";
import ReportConstructorChartToolPanel from "./ReportConstructorChartToolPanel";

class ReportContructorCustom extends Component {
  constructor(props) {
    super(props);

    this.state = {
      report: null,
    };
  }

  componentDidMount() {
    const { reportsListDataState, onGetReportsList } = this.props;

    if (reportsListDataState === states.NOT_REQUESTED) {
      onGetReportsList();
    }

    this.setReportState();
  }

  setReportState() {
    const { selectedCustomReportId, reportsListData, reportsListDataState } = this.props;
    const { report } = this.state;

    if (window.location.pathname === "/controls/reportConstructor") {
      const { onUnselectedCustomReport } = this.props;
      onUnselectedCustomReport();
    }

    if (selectedCustomReportId !== null && report === null && reportsListDataState === states.READY) {
      const _report = reportsListData.filter((x) => {
        return x.id === selectedCustomReportId;
      })[0];

      this.setState({ report: _report });
    }
  }

  componentDidUpdate(prevProps) {
    this.setReportState();
  }

  onCancelConstructor() {
    const { onUnselectedCustomReport } = this.props;
    onUnselectedCustomReport();
  }

  render() {
    const { report } = this.state;

    if (report === null || report === undefined) {
      return null;
    }

    return (
      <div className={styles.reportCustomConstrorContainer}>
        <div className={styles.reportCustomConstrorTitlePanel}>
          <ReportConstructorTitleEdit report={report} />
          <TooltipWrapper title={"Закрыть"} position="top">
            <div
              className={styles.reportCustomConstrorClose}
              onClick={(e) => {
                e.stopPropagation();
                this.onCancelConstructor();
              }}
            >
              <HighlightOffIcon />
            </div>
          </TooltipWrapper>
        </div>
        <div>{report.buildType === 2 ? <ReportConstructorChartToolPanel /> : <ReportConstructorToolPanel />}</div>
      </div>
    );
  }
}

export default withReportsList(withCustomReport(React.memo(ReportContructorCustom)));
